import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSite } from "../../lib/site-context";

export default function Footer() {
  const { settings, lang, t } = useSite();
  const nav = useNavigate();
  const c = settings?.contact || {};

  return (
    <footer className="border-t border-[var(--line)] bg-[var(--ink)] text-[var(--bg)] relative overflow-hidden" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 pt-20 pb-10">
        <div className="flex flex-col gap-10">
          <img src="/brand/logo-white.svg" alt="Dr. B.-Digitec" className="h-10 md:h-12 w-auto opacity-95 -ml-1" />
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-7">
              <div className="font-mono text-[11px] tracking-[0.2em] uppercase opacity-70 mb-6">
                {t("Zahnersatz vollständig digital organisiert.", "Dental prosthetics. Fully digital.")}
              </div>
              <h3 className="font-sans text-[clamp(2.2rem,6vw,5rem)] font-medium leading-[1.0] tracking-tight">
                {t("Bereit für den", "Ready for the")}<br/>
                <em className="font-light italic" style={{ color: "var(--accent)" }}>{t("digitalen Weg?", "digital path?")}</em>
              </h3>
              <Link
                to="/praxis-check"
                data-testid="footer-praxis-check"
                className="footer-main-action"
              >
                {t("Praxis-Check starten", "Start Practice-Check")}
              </Link>
            </div>

            <div className="md:col-span-5 grid grid-cols-2 gap-6 text-sm">
              <div>
                <div className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-50 mb-3">{t("Navigation", "Navigation")}</div>
                <ul className="space-y-2">
                  <li><Link className="hover:text-[var(--accent)]" to="/">{t("Home", "Home")}</Link></li>
                  <li><Link className="hover:text-[var(--accent)]" to="/workflow">Workflow</Link></li>
                  <li><Link className="hover:text-[var(--accent)]" to="/leistungen">{t("Leistungen", "Services")}</Link></li>
                  <li><Link className="hover:text-[var(--accent)]" to="/preisliste">{t("Preise", "Pricing")}</Link></li>
                  <li><Link className="hover:text-[var(--accent)]" to="/ueber-uns/veranstaltungen">{t("Veranstaltungen", "Events")}</Link></li>
                  <li><Link className="hover:text-[var(--accent)]" to="/ueber-uns">{t("Über uns", "About")}</Link></li>
                  <li><Link className="hover:text-[var(--accent)]" to="/presse">{t("Presse", "Press")}</Link></li>
                  <li><Link className="hover:text-[var(--accent)]" to="/wissen">{t("Wissen", "Knowledge")}</Link></li>
                </ul>
              </div>
              <div>
                <div className="font-mono text-[10px] tracking-[0.2em] uppercase opacity-50 mb-3">{t("Kontakt", "Contact")}</div>
                <address className="not-italic space-y-1 text-sm leading-relaxed">
                  <div>{c.company || "Dr. B.-Digitec"}</div>
                  <div>{c.street}</div>
                  <div>{c.zip} {c.city}</div>
                  <div>{c.country}</div>
                  {c.phone && <div><a href={`tel:${(c.phone || "").replace(/[^+\d]/g, "")}`} className="hover:text-[var(--accent)]">{c.phone}</a></div>}
                  {c.email && <div><a href={`mailto:${c.email}`} className="hover:text-[var(--accent)]">{c.email}</a></div>}
                </address>
              </div>
            </div>
          </div>

          <div className="overflow-hidden whitespace-nowrap py-6 border-y border-white/15">
            <div className="brut-marquee inline-flex gap-12 font-sans font-light italic text-[clamp(2rem,5vw,4rem)] leading-none">
              {Array.from({ length: 4 }).map((_, i) => (
                <span key={i} className="opacity-90">Scan · Prüfung · Konstruktion · Fertigung · Kontrolle · Express ·&nbsp;</span>
              ))}
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs opacity-70">
            <div>© {new Date().getFullYear()} Dr. B.-Digitec — {t("Vollständig digital organisiert", "Fully digital")}</div>
            <ul className="flex flex-wrap gap-6 font-mono uppercase tracking-[0.18em] text-[10px]">
              <li><Link to="/kontakt" data-testid="footer-kontakt" className="hover:text-[var(--accent)]">{t("Kontakt", "Contact")}</Link></li>
              <li><Link to="/impressum" className="hover:text-[var(--accent)]">{t("Impressum", "Imprint")}</Link></li>
              <li><Link to="/datenschutz" className="hover:text-[var(--accent)]">{t("Datenschutz", "Privacy")}</Link></li>
              <li><Link to="/wissen" className="hover:text-[var(--accent)]">{t("FAQ & Glossar", "FAQ & Glossary")}</Link></li>
            </ul>
            <button
              data-testid="footer-admin-login-trigger"
              aria-label="Admin-Bereich"
              title=""
              onClick={() => nav("/admin/login")}
              className="footer-admin-dot ml-auto"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
